import SignUpForm from 'components/features/signup/Signup';
import { SignUpProvider } from 'context/signup/signupcontext';
import React from 'react';
import { Link } from 'react-router-dom';

const Signup: React.FC = () => {
  const containerStyle = {
    paddingLeft: '40px',
  };

  return (
    <div>
      <div style={containerStyle}>
        <h1>Signup </h1>
        <Link to='/'>go back</Link>
      </div>
      <SignUpProvider>
        <SignUpForm></SignUpForm>
      </SignUpProvider>
    </div>
  );
};

export default Signup;
